import React, {useState, useEffect, useRef} from 'react'
import {Grid} from "@material-ui/core";
import HeaderComponent from "../../components/header/headercomponent";
import {HOME_SUBTITLE, WEBSITE_TITLE} from "../../constants/appconstants";
import PersonIcon from "@material-ui/icons/Person";
import style from './home.module.css'
import Typography from "@material-ui/core/Typography";
import {mfaVerifyTokenService} from "@app/common/services/mfaverifytokenservice";
import get from "lodash/get";
import {MFA_OTP_WRONG_ERR, MFA_VER_SUC_200, MFA_VER_SUC_201, VAL_TOK_SUC_200} from "@app/common/constants/constants";
import {CHANGE_PASSWORD_ROUTE} from "../../constants/routeconstants";
import {bindActionCreators, compose} from "redux";
import {loadAccess, loadLevel, loadSessionExpired, loadUser, setLoading} from "@app/common/store/action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {validateSessionService} from "@app/common/services/validatesessionservice";
import CaseRetreival from '../../assets/img/home/case-retreival.png'
import MenuGrid from "../../components/menugrid/menugrid";
import {appList} from "./homeconstants";
import {uniqBy} from 'lodash'
import IdleTimer from "react-idle-timer";
import Cookies from 'js-cookie';


function HomePage(props){
    let remainTimeRef= useRef(null)
    const handleChangePassword = ()=>{
        props.history.push("/change-password?backurl=true")
    }

    const handleLogout = ()=>{
        props.history.push("/")
    }

    const [state,setState] = useState({

        headerList:[
            {
                name:"accountList",
                icon:<PersonIcon style={{width:"30px",height:"30px",color:"#ffffff"}}/>,
                menuList:[
                    {
                        type:"cp",
                        text:"Change Password",
                        customFunc:handleChangePassword,
                        access:true
                    },
                    {
                        type:"logout",
                        text:"Logout",
                        customFunc:handleLogout,
                        access:true
                    }
                ]
            }
        ],
        appFinalList:[]
})

    useEffect(()=>{
        fetchData();

    },[])

     const fetchData = async ()=>{
        console.log("home fetchData")
         const {actions}= props;
         props.actions.setLoading(true);
         try{
             console.log("home validateSessionService123")
             let response = await validateSessionService();
             console.log("home validateSessionService")
             let serviceResponseHeader = get(response,"serviceResponseHeader");
             let serviceResponseBody = get(response,"serviceResponseBody");
             let statusCode = get(serviceResponseHeader,"statusCode");
             console.log("home statusCode123",statusCode)
             actions.setLoading(false);
             console.log("home statusCode",statusCode)
             if (statusCode === VAL_TOK_SUC_200){
                 let groups = get(serviceResponseBody,"permission")
                 console.log("home groups",groups)
                 configureAccess(groups)

             } else if(statusCode === MFA_VER_SUC_201)
                 props.history.push(CHANGE_PASSWORD_ROUTE)
         }catch(e){
             console.log(e)
             actions.setLoading(false);
             // if(e === MFA_OTP_WRONG_ERR)
             //     setOTPErrorStatus(true);
             // setErrorText(e)
             // setCode("")
             //  this.setState({ errorText:e,userName: "",password: "", buttonDisabled:true});
         }
     }

     const configureAccess = (groups)=>{
           let appAccessList=[];
           let appUniqueList = []
          appList.forEach((apps)=>{
              let permission= get(apps,"permission","");
              groups.forEach(access=>{
                  if(permission.includes(access)){
                      appAccessList.push(get(apps,"appDetails",{}))
                  }
              })
          })
         appUniqueList = uniqBy(appAccessList,function(e){
             return e.id
         })
        setState({...state,appFinalList:appUniqueList})
     }

    const onIdle = ()=>{
        console.log("idletimer idle expired")
        props.actions.loadSessionExpired(true)
    }

    const onAction = (e)=>{

        console.log("idletimer onaction called")
    }
    const getRemainingTime = (time)=>{
        console.log("idletimer getRemainingTime called",time)
    }
    return(
        <IdleTimer
            onIdle={onIdle}
            ref={remainTimeRef}
            onAction={onAction}
            timeout={900000}
            //timeout={60000}
            >

        <Grid container className={style.homepage_container}>
            <Grid item className={style.home_page_header_container}>
                <HeaderComponent
                    title={WEBSITE_TITLE}
                    headerList = {state.headerList}/>
                {console.log("idletimer getRemainingTime remainTimeRef",remainTimeRef)}
                {  remainTimeRef.current!=null?console.log("idletimer getRemainingTime",remainTimeRef.current.getRemainingTime()):""}
            </Grid>
            <Grid item className={style.home_page_pic_container}/>
            <Grid item>
                <Grid container justify={"center"} alignItems={"center"}>
                    <Grid item className={style.home_page_bottom_text_container}>
                        <Typography className={style.home_page_subtitle_text}> {HOME_SUBTITLE}
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>
            <Grid item className={style.home_page_card_container}>
                <MenuGrid list={state.appFinalList}/>
            </Grid>
            {/*<FileDownloadGrid startDownload={props.download}/>*/}
        </Grid>
        </IdleTimer>
    )
}

const mapStateToProps = (state, ownProps) => ({
    access: state.access,
    session:state.session,
    user:state.user,
    download:state.download
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { loadAccess, loadLevel, setLoading, loadUser,loadSessionExpired },
            dispatch
        ),
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(HomePage);